import React from 'react';
import { connect } from 'react-redux';
import P from '@leverege/promise';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { Button } from '@leverege/ui-elements';
import { Blocker } from '@leverege/molten/views';
import { jsx as _jsx } from "react/jsx-runtime";
class TagAssetLink extends React.Component {
  constructor(props) {
    super(props);
    const {
      value,
      object
    } = props;
    console.log(object, 'Object');
    this.initialLoad = P.deferred();
    if (value && value !== '-') {
      let ref = object.ref;
      if (ref.indexOf('tags') > -1) {
        ref = ref.replace('tags', 'assets');
        ref = ref.endsWith('assets') ? ref : trimRef(ref);
      } else if (ref.indexOf('tag') > -1) {
        ref = ref.replace('tag', 'asset');
        ref = ref.endsWith('asset') ? ref : trimRef(ref);
      }
      const assetObj = {
        id: value,
        ref,
        type: 'asset'
      };
      this.assetActions = DataSources.getActions(assetObj);
      console.log({
        assetActions: this.assetActions,
        assetObj
      }, 'Asset Actions');
    }
  }
  componentDidMount() {
    const {
      value,
      asset
    } = this.props;
    if (!asset && value && this.assetActions) {
      GlobalState.dispatch(this.assetActions.get()).then(() => {
        this.initialLoad.resolve();
      });
    } else {
      this.initialLoad.resolve();
    }
  }
  onClick = () => {
    GlobalState.dispatch(this.assetActions.parent().goTo(this.assetActions.id));
  };
  renderChildren = () => {
    const {
      asset
    } = this.props;
    if (asset) {
      return /*#__PURE__*/_jsx(Button, {
        variant: "detailSecondary",
        onClick: this.onClick,
        children: "Go To Asset"
      });
    }
    return null;
  };
  render() {
    const matchContext = {
      client: 'TagAssetLink'
    };
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: matchContext,
      context: this.props,
      hooks: [{
        execute: () => this.initialLoad
      }],
      render: this.renderChildren,
      small: true,
      loadingProps: {
        inline: true
      }
    });
  }
}
export default connect((state, props) => {
  const {
    value
  } = props;
  const {
    models: {
      lookup
    }
  } = state;
  const asset = lookup[value];
  return {
    asset
  };
})(TagAssetLink);
function trimRef(ref) {
  const arr = ref.split('/');
  arr.pop();
  return arr.join('/');
}